import { yupResolver } from "@hookform/resolvers/yup";
import { 
  Create, 
  Box, 
  TextField, 
} from "@pankod/refine-mui";
import * as Yup from "yup";
import { useForm } from "@pankod/refine-react-hook-form";

const schema = Yup.object({
  user_id: Yup.number().required(),
  title: Yup.string().trim().required(),
  desc: Yup.string().trim().required(),
});

interface formDataType {
  user_id: number;
  title: string;
  desc: string;
}

export const NotificationCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
  } = useForm<formDataType>({ resolver: yupResolver(schema) });

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("user_id", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.user_id}
          helperText={(errors as any)?.user_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="User Id"
          name="user_id"
        />
        <TextField
          {...register("title", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.title}
          helperText={(errors as any)?.title?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Title"
          name="title"
        />
        <TextField
          {...register("desc", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.desc}
          helperText={(errors as any)?.desc?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Desc"
          name="desc"
        />
      </Box>
    </Create>
  );
};
